import type { Article } from "@/data/articles";

// ————————————————————————————————————————————————
// Značke za /navdih (Navdih & zgodbe) — 8 kategorij, hevrističen izbor po naslovu/izvlečku.
// ————————————————————————————————————————————————
export type NavdihTag =
  | "Darila zanjo"
  | "Darila zanj"
  | "Otroci & krst"
  | "Poroka & obletnice"
  | "Praznično"
  | "Dom & nega"
  | "Nakit"
  | "Slovenska obrt";

const NAVDIH_RULES: { tag: NavdihTag; kw: RegExp }[] = [
  { tag: "Otroci & krst", kw: /\b(krst|novorojen|otro[škk]|dojen[čc]|za rojstvo|za dojen|za sina|za h[čc]er)\b/i },
  { tag: "Poroka & obletnice", kw: /\b(porok|obletnic|poro[čc]n|zaroka|zaro[čc]|zavit denar)\b/i },
  { tag: "Praznično", kw: /\b(valentin|materinsk|o[čc]etovsk|bo[žz]i[čc]|novoletn|velika no[čc]|nikolaj|miklav[žz]|adventn|praz)/i },
  { tag: "Darila zanjo", kw: /\b(zanjo|za mamo|za babico|za sestro|za u[čc]iteljic|za sodelavko|za [žz]en|za punc|za dekle)\b/i },
  { tag: "Darila zanj", kw: /\b(zanj|za o[čc]et|za dedka|za brata|za mo[žs]k|za fant|za sodelavc|za u[čc]itelj\b)/i },
  { tag: "Nakit", kw: /\b(nakit|zapestnic|prstan|uhan|ogrlic|verižic)/i },
  { tag: "Dom & nega", kw: /\b(sve[čc]|hidrolat|mila?|kopaln|krem|keramik|vosek|torbic|skodelic|dom(a|ov)?\b)/i },
  { tag: "Slovenska obrt", kw: /\b(slovensk|ro[čc]no|ro[čc]n[oe] delo|obrt|klekljan|makram|volnen|volnene|tradicij)/i },
];

export function inferNavdihTags(a: Article): NavdihTag[] {
  const hay = `${a.title} ${a.excerpt}`;
  const tags = new Set<NavdihTag>();
  for (const { tag, kw } of NAVDIH_RULES) if (kw.test(hay)) tags.add(tag);
  return Array.from(tags);
}

export const NAVDIH_TAG_ORDER: NavdihTag[] = [
  "Darila zanjo",
  "Darila zanj",
  "Otroci & krst",
  "Poroka & obletnice",
  "Praznično",
  "Dom & nega",
  "Nakit",
  "Slovenska obrt",
];

// ————————————————————————————————————————————————
// Značke za /predstavitev-prodajalca — 3 tematski sklopi.
// ————————————————————————————————————————————————
export type PredstavitevTag = "Zakonodaja" | "Spletna predstavitev" | "Oglaševanje";

const OGLASEVANJE = /\b(instagram|facebook|tiktok|youtube|pinterest|vpliv|e-?mail|e-?po[šs]t|forum|skupnost|socialn)/i;
const ZAKONODAJA = /\b(ODD|s\.p\.|davk|osebn[ei]?ga? dopolnil|registracij[ae] osebn|popoldansk)/i;

export function inferPredstavitevTag(a: Article): PredstavitevTag {
  const hay = `${a.title} ${a.excerpt}`;
  if (ZAKONODAJA.test(hay)) return "Zakonodaja";
  if (OGLASEVANJE.test(hay)) return "Oglaševanje";
  return "Spletna predstavitev";
}

export const PREDSTAVITEV_TAG_ORDER: PredstavitevTag[] = [
  "Zakonodaja",
  "Spletna predstavitev",
  "Oglaševanje",
];
